export interface BankConfig {
  _id: string;
  bankName: string;
  accountCode: number;
  fieldName: string;
  fieldValue: string | boolean | number | string[];
  userInterActionType: UserInteractionType;
  displayName: string;
  description: string;
}

export enum UserInteractionType {
  SELECT = 'SELECT',
  INPUT = 'INPUT',
  CHECKBOX = 'CHECKBOX',
  NONE = 'NONE',
}

export interface BankConfigQueryArgs {
  companyId: string;
  bankConfig: SimpleBankConfig;
}

export interface SimpleBankConfig {
  accountNr: string;
  fieldName: string;
  fieldValue: string;
}
